export default __webpack_public_path__ + "static/media/logout.ac1c9171.svg";